export enum RegisterStep {
  main,
  createAccount,
  registerUser,
  securityFilter,
  securityPin,
  emailSent,
}
